import * as actions from '../types';
import CMX from '../../api';
import {dialogOpen, dialogClose} from './dialogs';
import {getCheckoutSession, getCheckoutCinema, getCheckoutStep, isPaymentSuggestionNeeded, getCheckoutContext} from '../../reducers';

export const CHECKOUT_CONTEXT_TICKETS = 'session';
export const CHECKOUT_CONTEXT_CANDYBAR = 'candybar';
export const CHECKOUT_CONTEXT_LOYALTY = 'loyalty';
export const CHECKOUT_CONTEXT_LOYALTY_PACKAGES = 'loyalty-packages';
export const CHECKOUT_CONTEXT_SIGN_UP = 'sign-up';
export const CHECKOUT_CONTEXT_GIFT_CARD = 'gift-card';

export const sessionFetch = (sessionId) => {
  return dispatch => {
    dispatch({type: actions.CHECKOUT_INIT});
    dispatch(sessionIsLoading(true));

    return CMX.get('sessions/' + sessionId)
        .then(data => {
          dispatch(sessionFetchSuccess(data));
          dispatch(sessionIsLoading(false));
        })
        .catch((error) => dispatch(sessionFetchError(error)) );
  }
};

export const sessionIsLoading = (isLoading) => ({
  type: actions.CHECKOUT_SESSION_IS_LOADING,
  isLoading,
});

export const sessionFetchError = error => ({
  type: actions.CHECKOUT_SESSION_FETCH_ERROR,
  error
});

export const sessionFetchSuccess = (data) => ({
  type: actions.CHECKOUT_SESSION_FETCH_SUCCESS,
  data,
});

export const nextStep = () => ({
  type: actions.CHECKOUT_NEXT_STEP,
});

export const prevStep = () => ({
  type: actions.CHECKOUT_PREV_STEP,
});

export const checkoutSetStep = (step) => ({
  type: actions.CHECKOUT_SET_STEP,
  step
});

export const paymentMethodSelect = (method, {mayNeedExternalUrl})  => ({
  type: actions.CHECKOUT_PAYMENT_METHOD_SELECT_BEFORE,
  method,
  mayNeedExternalUrl
});

export const paymentMethodCancel = () => ({
  type: actions.CHECKOUT_PAYMENT_METHOD_CANCEL,
});

export const onCheckoutUnmount = () => ({
  type: actions.CHECKOUT_ABANDON,
});

let timer = null;

export const timerStart = timeoutUnix => dispatch => {
  clearInterval(timer);
  timer = setInterval(() => dispatch(timerTick()), 1000);
  dispatch({type: actions.CHECKOUT_TIMER_START, timeoutUnix});
  dispatch(timerTick());
};

export const timerTick = () => (dispatch, getState) => {
  if (getState().checkoutData.timer.time <= 0) {
    dispatch(timerTimeout());
  } else {
    dispatch({
      type: actions.CHECKOUT_TIMER_TICK,
    });
  }
};

export const timerStop = () => dispatch => {
  clearInterval(timer);
  timer = null;
  dispatch({type: actions.CHECKOUT_TIMER_STOP});
};

export const timerResume = () => dispatch => {
  if (!timer) {
    timer = setInterval(() => dispatch(timerTick()), 1000);
  }

  dispatch({type: actions.CHECKOUT_TIMER_RESUME});
  dispatch(timerTick());
};

export const timerTimeout = () => dispatch => {
  clearInterval(timer);
  timer = null;
  dispatch({type: actions.CHECKOUT_TIMER_TIMEOUT});
};

export const preCheckoutConfirm = payload => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(dialogOpen({
      message: `Has seleccionado <strong>${payload.movie}</strong> -
        <strong>${payload.version}</strong> para el día <strong>${payload.date}</strong>
        a las <strong>${payload.time}</strong> en <strong>${payload.cinema}</strong>.`,
      buttons: [
        {
          label: 'Volver',
          onClick: (dialog) => {
            dispatch(dialogClose(dialog.id));
            reject();
          }
        },
        {
          label: 'Continuar',
          primary: true,
          onClick: (dialog) => {
            dispatch(dialogClose(dialog.id));
            setTimeout(function() { // For some reason at some version of Chrome it started crashing here, so this is a workaround.
              resolve();
            }, 10);
          }
        }
      ]
    }));
  });
};

export const setCheckoutTermsCheck = checked => ({
  type: actions.CHECKOUT_SET_TERMS_CHECK,
  checked
});

export const displayNoTermsCheckedDialog = () => dispatch => {
  dispatch(dialogOpen({
    message: 'Para continuar debes aceptar los términos y condiciones y el aviso de privacidad.',
    buttons: [
        {
            label: 'Entendido',
            primary: true,
            onClick: (dialog) => {
                dispatch(dialogClose(dialog.id));
            }
        },
    ]
  }));
}

export const checkoutLoaded = type => ({
  type
});
